import { Skeleton } from 'antd';
import { useIsTerminalMode } from 'hooks/useIsTerminalMode';
import * as Styled from './styles';

const BTN_STYLE = { width: '50px', height: 20, margin: 0 };

export const NftBlockchainSkeleton = () => {
  const { isTerminalMode } = useIsTerminalMode();

  return (
    <Styled.BlockchainTable $isLarge={isTerminalMode}>
      <div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
      </div>
      <div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
      </div>
      <div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
        <div>
          <Skeleton.Button active style={BTN_STYLE} shape="round" />
        </div>
      </div>
    </Styled.BlockchainTable>
  );
};
